import { WprBaseValidator } from '../../../wpr-framework/view/validation/WprBaseValidator';

/**
 * パスワードバリデータ
 */
export class PassCombinationValidator extends WprBaseValidator {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('パスワード組み合わせ');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 入力値チェック
	 * @param value 入力値
	 * @param option チェックオプション
	 * @returns trueの場合、成功
	 */
	public checkValidValue(value: any, option?: any): boolean {
		if (!value)
			return true;
		if (typeof (value) === 'string' || value instanceof String) {
			if (this.passValid(value))
				return true;
		}
		return false;
	}

	/**
	 * エラーメッセージ取得
	 * @param option オプション
	 * @returns エラーメッセージ
	 */
	public getErrorMessage(option?: any): string {
		return '大文字英字、小文字英字、数字、記号から2種類以上を使用してください';
	}
	// --------------------------------------------------------------------------
	
	// privateメソッド -----------------------------------------------------------
	/**
	* パスワードバリデーション（大文字英語・小文字英語・数字・記号のいずれか２種類を含む）
    * @param value
	* @returns 条件を満たす場合、true
	*/
	private passValid(value: any): boolean {
		let count = 0;
		if (value.match(/^.*[a-z].*$/g))
			count++;
		if (value.match(/^.*[A-Z].*$/g))
			count++;
		if (value.match(/^.*[0-9].*$/g))
			count++;
		if (value.match(/^.*[-_.*!#$%&+/=?^`{|}~@].*$/g))
			count++;
		if (count >= 2)
			return true;
		else
			return false;
	}
	// --------------------------------------------------------------------------
}
